import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services';
import {
  parseUsersFiltersFromStorage,
  serializeUsersFilters,
} from '../filters';
import { APP } from '../config/app';
import { UserSortType } from '../models/enums';

/**
 * Hydrates the URL from localStorage *before* the resolver runs (single API call
 * per sidebar entry). See {@link bookingsHydrationGuard} for the rationale.
 */
export const usersHydrationGuard: CanActivateFn = async (route, state) => {
  if (route.queryParamMap.keys.length > 0) return true;

  const storage = inject(StorageService);
  const router = inject(Router);

  const queryParams: { [key: string]: string | number } = {};

  const storedFilters = parseUsersFiltersFromStorage(await storage.getUsersFilters());
  if (storedFilters) {
    const serialized = serializeUsersFilters(storedFilters);
    // The list type lives in the path (/users vs /drivers), never in the URL params
    delete serialized['types'];
    for (const [k, v] of Object.entries(serialized)) {
      if (v != null && v !== '') queryParams[k] = v as string;
    }
  }

  const storedSort = await storage.getUserSortType();
  if (storedSort && storedSort !== UserSortType.CREATION) {
    queryParams['sort'] = storedSort;
  }

  const storedSize = await storage.getUsersPageSize();
  if (storedSize && storedSize > 0 && storedSize !== APP.DEFAULT_PAGE_SIZE) {
    queryParams['size'] = storedSize;
  }

  if (Object.keys(queryParams).length === 0) return true;

  const path = state.url.split('?')[0];
  return router.createUrlTree([path], { queryParams });
};
